export const LOGO = "https://blog.yorksj.ac.uk/moodle/files/2017/02/social-1834013_640.png";

